import { AxiosInstance } from "axios";

export const APP_MULTI_USER_API = "APP_MULTI_USER_API";
export const ASSISTANTS_WITH_THREADS = "ASSISTANTS_WITH_THREADS";
export const APP_SERVICES = [
  "assistants",
  "classify",
  "llm_compare",
  "dialogs",
  "ai_agents_spa",
  "ai_agents_extra_app",
  "practicum",
  "cases",
  "stylizator",
  "research",
  "userfiles",
];

let APP_VECTOR_STORE_MODE = "";
if (process.env.REACT_APP_ENV_SOURCE === "dev") {
  APP_VECTOR_STORE_MODE = process.env.REACT_APP_VECTOR_STORE_MODE || "";
} else {
  APP_VECTOR_STORE_MODE =
    // @ts-ignore
    window.__RUNTIME_CONFIG__?.REACT_APP_VECTOR_STORE_MODE;
}

let APP_DRAWIO_URL = "";
if (process.env.REACT_APP_ENV_SOURCE === "dev") {
  APP_DRAWIO_URL = process.env.REACT_APP_DRAWIO_URL || "";
} else {
  APP_DRAWIO_URL =
    // @ts-ignore
    window.__RUNTIME_CONFIG__?.REACT_APP_DRAWIO_URL;
}

let APP_WHITEBOARD = "";
if (process.env.REACT_APP_ENV_SOURCE === "dev") {
  APP_WHITEBOARD = process.env.REACT_APP_WHITEBOARD || "";
} else {
  APP_WHITEBOARD =
    // @ts-ignore
    window.__RUNTIME_CONFIG__?.REACT_APP_WHITEBOARD;
}

let APP_GIT = "";
if (process.env.REACT_APP_ENV_SOURCE === "dev") {
  APP_GIT = process.env.REACT_APP_GIT || "";
} else {
  APP_GIT =
    // @ts-ignore
    window.__RUNTIME_CONFIG__?.REACT_APP_GIT;
}

let APP_AI_SCORING_URL = "";
if (process.env.REACT_APP_ENV_SOURCE === "dev") {
  APP_AI_SCORING_URL = process.env.REACT_APP_AI_SCORING_URL || "";
} else {
  APP_AI_SCORING_URL =
    // @ts-ignore
    window.__RUNTIME_CONFIG__?.REACT_APP_AI_SCORING_URL;
}

let APP_DEERFLOW_API_INSTANCES: Map<string, AxiosInstance> = new Map();

export {
  APP_VECTOR_STORE_MODE,
  APP_DRAWIO_URL,
  APP_AI_SCORING_URL,
  APP_DEERFLOW_API_INSTANCES,
  APP_WHITEBOARD,
  APP_GIT,
};
